import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarcodeExportConfigurationContext } from '../../../../context/BarcodeExportConfigurationContext';
import { useToast } from '../../../../providers/ToastProvider';
import { BarcodeExportConfigurationRequest } from '../../../../requests/barcodeExportConfiguration.request';
import { useRequest } from '../../../../requests/common/requestHook';
import {
  BarcodeExportConfiguration,
  BarcodeExportConfigurationInput,
} from '../../../../types/barcode_export_configuration';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import { Breadcrumbs, Crumb } from '../../../components/Breadcrumbs';
import BarcodeSettingsCrumb from '../../../components/Breadcrumbs/crumbs/BarcodeExportConfigurationSettingsCrumb';
import { ToastType } from '../../../components/Toast';
import BarcodeExportConfigurationInputPane from './BarcodeExportConfigurationInputPane';

export default function BarcodeExportConfigurationCreateScreen() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { barcodeExportConfigurations } = useContext(BarcodeExportConfigurationContext);

  const [create, { loading }] = useRequest(BarcodeExportConfigurationRequest.create);

  const handleSave = async (configuration: BarcodeExportConfigurationInput) => {
    const response = await create({ data: [configuration.forCreate()] });

    if (response) {
      response.forEach((config: BarcodeExportConfiguration) => {
        barcodeExportConfigurations.set(config.id, new BarcodeExportConfiguration(config));
      });
      navigate(Routing.settings.barcodes.overview());
      showToast({
        type: ToastType.success,
        title: translate({ key: TranslationKey.barcodeExportConfigurationCreatedSuccessfullyToast }),
      });
    }
  };

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <BarcodeSettingsCrumb />
        <Crumb
          text={translate({ key: TranslationKey.createBarcodeExportConfiguration })}
          path={Routing.settings.barcodes.create()}
          current
        />
      </Breadcrumbs>

      <div className='content-x content-y-breadcrumbs flex flex-grow flex-col overflow-auto'>
        <BarcodeExportConfigurationInputPane onSave={handleSave} loading={loading} />
      </div>
    </div>
  );
}
